import '@/lib/sentry'

import { ErrorBoundary } from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { queryClient } from '@/config/query-client'
import { AuthContextProvider } from '@/contexts/auth-context'
import { CompanyContextProvider } from '@/contexts/company-context'
import { FeaturedContextProvider } from '@/contexts/featured-context'
import { UnauthorizedContextProvider } from '@/contexts/unauthorized-context'
import { router } from '@/routes'

export const App = () => (
  <ErrorBoundary fallback={<p>Ocorreu um erro inesperado.</p>}>
    <QueryClientProvider client={queryClient}>
      <FeaturedContextProvider>
        <AuthContextProvider>
          <UnauthorizedContextProvider>
            <CompanyContextProvider>
              <RouterProvider router={router} />
            </CompanyContextProvider>
          </UnauthorizedContextProvider>
        </AuthContextProvider>
      </FeaturedContextProvider>
    </QueryClientProvider>
  </ErrorBoundary>
)
